import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';

@Directive({
  selector: '[appFixScroll]',
})
export class FixScrollDirective {
  @Input() offset: number = 0;
  @Input() howFar: number = 0;
  @Input() startingPos: number = 0;
  prevScrollPos: number;

  constructor(
    private element: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    // this.element.nativeElement.style.top = `${this.howFar}px`;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (this.document.defaultView.innerWidth <= 991) {
      return;
    }

    let currentScrollPos = this.document.defaultView.scrollY;

    if (this.prevScrollPos > currentScrollPos) {
      this.element.nativeElement.style.top = `${this.howFar}px`;
    } else {
      this.element.nativeElement.style.top = `${this.startingPos}px`;
    }
    this.prevScrollPos = currentScrollPos;
  }
}
